export default __webpack_public_path__ + "static/media/calendar.20ff9fe8.svg";